import React, { useState, useEffect, useRef } from "react";
import "./Dashboard.scss";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { auth, db } from "../../firebase";
import { getAuth, signOut } from "firebase/auth";
import AccountCircleIcon from "@mui/icons-material/Person";
import "./Dashboarddark.scss";
// No need for separate React imports
const Dashboard = ({ selectedTab }) => {
  const column1Ref = useRef(null);
  const column2Ref = useRef(null);
  const [column1Data, setColumn1Data] = useState([]);
  const [column2Data, setColumn2Data] = useState([]);
  const [onNowRight, setOnNowRight] = useState([]);
  const [onNowLeft, setOnNowLeft] = useState([]);
  const [onLaterRight, setOnLaterRight] = useState([]);
  const [onLaterLeft, setOnLaterLeft] = useState([]);
  const [onNow, setOnNow] = useState([]);
  const [onLater, setOnLater] = useState([]);
  const [showW2W, setShowW2W] = useState(false);
  const [scrollDirection, setScrollDirection] = useState(1);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [currentView, setCurrentView] = useState("memos");
  const [weatherAlerts, setWeatherAlerts] = useState([]);
  const [units, setUnits] = useState([]);
  const [rotationFiles, setRotationFiles] = useState([]);
  const [currentRotationIndex, setCurrentRotationIndex] = useState(0);
  const [socialLinks, setSocialLinks] = useState(null);
  const [socialMediaItems, setSocialMediaItems] = useState([]);
  const [combinedRotationItems, setCombinedRotationItems] = useState([]);
  const [dutyCrewScreen, setdutyCrewScreen] = useState(true);
  const [leadershipScreen, setLeadershipScreen] = useState(false);
  const [leadershipData, setLeadershipData] = useState([]);
  const [leadershipTheme, setLeadershipTheme] = useState('classicRed');
  const [agencyLogo, setAgencyLogo] = useState('');
  const [agencyDescription, setAgencyDescription] = useState('');
  const [agencyDisplayName, setAgencyDisplayName] = useState('');
  const [socialMediaAnimationKey, setSocialMediaAnimationKey] = useState(0);
  const [googleCalendar, setGoogleCalendar] = useState(false);
  const [googleCalendarUrl, setGoogleCalendarUrl] = useState('');
  const [departmentCalendar, setDepartmentCalendar] = useState(false);
  const [departmentCalendarEvents, setDepartmentCalendarEvents] = useState([]);
  const [countdownSeconds, setCountdownSeconds] = useState(10);
  const [totalDuration, setTotalDuration] = useState(10);
  const [unitDataSource, setUnitDataSource] = useState('rigcheck');
  const [agencyName, setAgencyName] = useState('');
  const [unitSubPage, setUnitSubPage] = useState(0);
  const dutyCrewScrollRef = useRef(null);

  // Function to fetch weather alerts from NOAA API
  const fetchWeatherAlerts = async () => {
    try {
      const response = await fetch('https://api.weather.gov/alerts/active?point=40.7298,-73.1926');
      const data = await response.json();
      if (data.features) {
        setWeatherAlerts(data.features);
      }
    } catch (error) {
      console.error('Error fetching weather alerts:', error);
    }
  };

  // Function to fetch rotation files and social media from agency stationboard document with real-time updates
  const fetchRotationFiles = async (agencyName, unsubscribeFunctions) => {
    try {
      if (!agencyName) return;

      const stationBoardCollection = collection(db, agencyName + " Station Board");
      const unsubscribeStationBoard = onSnapshot(stationBoardCollection, (querySnapshot) => {
        console.log('Station Board collection updated, processing documents...');

        if (querySnapshot.empty) {
          console.log("No station board found for agency:", agencyName);
          setRotationFiles([]);
          setSocialLinks(null);
          setSocialMediaItems([]);
          return;
        }

        let foundRotation = false;
        let foundSocialLinks = false;

        // Check each document in the collection for rotation array and social links
        querySnapshot.forEach((dept) => {
          const deptData = dept.data();
          console.log('Checking document:', dept.id, 'Data:', deptData);

          // Handle rotation files
          if (deptData.rotation && Array.isArray(deptData.rotation)) {
            console.log('Found rotation array:', deptData.rotation);
            console.log('Current rotation files:', rotationFiles);
            console.log('Arrays are equal:', JSON.stringify(rotationFiles) === JSON.stringify(deptData.rotation));

            // Always update rotation files and reset rotation state
            setRotationFiles(deptData.rotation);

            // Reset rotation index if array changed
            if (JSON.stringify(rotationFiles) !== JSON.stringify(deptData.rotation)) {
              console.log('Rotation files changed, resetting rotation index to 0');
              setCurrentRotationIndex(0);
              setCurrentPdfPage(1);
            }

            foundRotation = true;
          }

          // Handle social links
          if (deptData.socialLinks) {
            console.log('Found social links:', deptData.socialLinks);
            console.log('Social links type:', typeof deptData.socialLinks);
            console.log('Social links keys:', Object.keys(deptData.socialLinks));
            setSocialLinks(deptData.socialLinks);
            createSocialMediaItems(deptData.socialLinks);
            foundSocialLinks = true;
          }

          // Handle dutyCrewScreen setting
          if (deptData.hasOwnProperty('dutyCrewScreen')) {
            console.log('Found dutyCrewScreen setting:', deptData.dutyCrewScreen);
            setdutyCrewScreen(deptData.dutyCrewScreen);
          } else {
            console.log('No dutyCrewScreen setting found, defaulting to true');
            setdutyCrewScreen(true);
          }

          // Handle leadership screen setting
          if (deptData.hasOwnProperty('leadershipScreen')) {
            console.log('Found leadershipScreen setting:', deptData.leadershipScreen);
            setLeadershipScreen(deptData.leadershipScreen);
          } else {
            console.log('No leadershipScreen setting found, defaulting to false');
            setLeadershipScreen(false);
          }

          // Handle leadership data
          if (deptData.leadership && Array.isArray(deptData.leadership)) {
            console.log('Found leadership data:', deptData.leadership);
            setLeadershipData(deptData.leadership);
          }

          // Handle leadership theme
          if (deptData.leadershipTheme) {
            setLeadershipTheme(deptData.leadershipTheme);
          } else {
            setLeadershipTheme('classicRed');
          }

          // Handle Google Calendar settings
          if (deptData.hasOwnProperty('googleCalendar')) {
            console.log('Found googleCalendar setting:', deptData.googleCalendar);
            setGoogleCalendar(deptData.googleCalendar);
          } else {
            console.log('No googleCalendar setting found, defaulting to false');
            setGoogleCalendar(false);
          }

          if (deptData.googleCalendarUrl) {
            console.log('Found googleCalendarUrl:', deptData.googleCalendarUrl);
            setGoogleCalendarUrl(deptData.googleCalendarUrl);
          } else {
            console.log('No googleCalendarUrl found');
            setGoogleCalendarUrl('');
          }

          // Handle Department Calendar settings
          if (deptData.hasOwnProperty('departmentCalendar')) {
            console.log('Found departmentCalendar setting:', deptData.departmentCalendar);
            setDepartmentCalendar(deptData.departmentCalendar);
          } else {
            console.log('No departmentCalendar setting found, defaulting to false');
            setDepartmentCalendar(false);
          }

          // Handle unitDataSource setting
          if (deptData.unitDataSource && deptData.unitDataSource.trim() !== '') {
            console.log('Found unitDataSource setting:', deptData.unitDataSource);
            setUnitDataSource(deptData.unitDataSource);
          } else {
            console.log('No unitDataSource setting found, defaulting to rigcheck');
            setUnitDataSource('rigcheck');
          }
        });

        // Set defaults if nothing found
        if (!foundRotation) {
          console.log('No rotation files found, clearing rotation state');
          setRotationFiles([]);
          setCurrentRotationIndex(0);
          setCurrentPdfPage(1);
          setCombinedRotationItems([]);
        }
        if (!foundSocialLinks) {
          setSocialLinks(null);
          setSocialMediaItems([]);
        }
      });

      // Add unsubscribe function to the array
      if (unsubscribeFunctions) {
        unsubscribeFunctions.push(unsubscribeStationBoard);
      }

      // Fetch department calendar events if enabled
      if (agencyName) {
        const calendarQuery = query(
          collection(db, `Agencies/${agencyName}/calendar`),
          orderBy('startDate', 'asc')
        );

        const unsubscribeCalendar = onSnapshot(calendarQuery, (snapshot) => {
          const eventsData = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
            startDate: doc.data().startDate?.toDate?.() || new Date(doc.data().startDate),
            endDate: doc.data().endDate?.toDate?.() || new Date(doc.data().endDate)
          }));
          console.log('Department calendar events updated:', eventsData);
          setDepartmentCalendarEvents(eventsData);
        });

        if (unsubscribeFunctions) {
          unsubscribeFunctions.push(unsubscribeCalendar);
        }
      }

    } catch (error) {
      console.error('Error setting up rotation files listener:', error);
      setRotationFiles([]);
      setSocialLinks(null);
      setSocialMediaItems([]);
    }
  };

  // Function to create social media items for rotation
  const createSocialMediaItems = (socialLinksData) => {
    console.log('Creating social media items from:', socialLinksData);
    const validPlatforms = [];

    // Collect valid social media platforms
    if (socialLinksData.facebook && socialLinksData.facebook.trim() !== '') {
      console.log('Adding Facebook:', socialLinksData.facebook);
      validPlatforms.push({
        platform: 'facebook',
        url: socialLinksData.facebook,
        name: 'Facebook'
      });
    } else {
      console.log('Facebook link not valid:', socialLinksData.facebook);
    }

    if (socialLinksData.instagram && socialLinksData.instagram.trim() !== '') {
      console.log('Adding Instagram:', socialLinksData.instagram);
      validPlatforms.push({
        platform: 'instagram',
        url: socialLinksData.instagram,
        name: 'Instagram'
      });
    } else {
      console.log('Instagram link not valid:', socialLinksData.instagram);
    }

    if (socialLinksData.twitter && socialLinksData.twitter.trim() !== '') {
      console.log('Adding Twitter:', socialLinksData.twitter);
      validPlatforms.push({
        platform: 'twitter',
        url: socialLinksData.twitter,
        name: 'Twitter'
      });
    } else {
      console.log('Twitter link not valid:', socialLinksData.twitter);
    }

    // Create a single combined social media item if we have any valid platforms
    const socialItems = [];
    if (validPlatforms.length > 0) {
      socialItems.push({
        type: 'social-combined',
        platforms: validPlatforms,
        name: 'Social Media'
      });
    }

    console.log('Created combined social media item:', socialItems);
    console.log('Valid platforms count:', validPlatforms.length);
    setSocialMediaItems(socialItems);
  };

  // Function to render combined social media embed
  const renderSocialMediaEmbed = (socialItem) => {
    console.log('Rendering social media embed for:', socialItem);
    const { platforms, name } = socialItem;

    // Helper function to create embed URL for a platform
    const createEmbedUrl = (platform, url, platformCount) => {
      try {
        if (platform === 'facebook') {
          const facebookUrl = encodeURIComponent(url);
          // Use a more stable Facebook embed approach
          return `https://www.facebook.com/plugins/page.php?href=${facebookUrl}&tabs=timeline&width=500&height=${platformCount === 1 ? '700' : platformCount === 2 ? '600' : '500'}&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=&locale=en_US`;
        } else if (platform === 'instagram') {
          // Instagram using SnapWidget - designed for kiosk/automated displays
          const username = url.split('/').filter(Boolean).pop().replace('@', '').replace('?hl=en', '');
          return `https://snapwidget.com/embed/${username}`;
        } else if (platform === 'twitter') {
          const twitterHandle = url.split('/').pop().replace('@', '');
          // Twitter widget with responsive parameters
          return `https://syndication.twitter.com/srv/timeline-profile/screen-name/${twitterHandle}?dnt=true&embedId=twitter-widget-0&features=eyJ0ZndfdGltZWxpbmVfbGlzdCI6eyJidWNrZXQiOltdLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X2ZvbGxvd2VyX2NvdW50X3N1bnNldCI6eyJidWNrZXQiOnRydWUsInZlcnNpb24iOm51bGx9LCJ0ZndfdHdlZXRfZWRpdF9iYWNrZW5kIjp7ImJ1Y2tldCI6Im9uIiwidmVyc2lvbiI6bnVsbH0sInRmd19yZWZzcmNfc2Vzc2lvbiI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfZm9zbnJfc29mdF9pbnRlcnZlbnRpb25zX2VuYWJsZWQiOnsiYnVja2V0Ijoib24iLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X21peGVkX21lZGlhXzE1ODk3Ijp7ImJ1Y2tldCI6InRyZWF0bWVudCIsInZlcnNpb24iOm51bGx9LCJ0ZndfZXhwZXJpbWVudHNfY29va2llX2V4cGlyYXRpb24iOnsiYnVja2V0IjoxMjA5NjAwLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X3Nob3dfYmlyZGhvdXNlX3BpdmdvdF9sYWJlbCI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfZHVwbGljYXRlX3NjcmliZXNfdG9fc2V0dGluZ3MiOnsiYnVja2V0Ijoib24iLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X3VzZV9wcm9maWxlX2ltYWdlX3NoYXBlX2VuYWJsZWQiOnsiYnVja2V0Ijoib24iLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X3ZpZGVvX2hsc19keW5hbWljX21hbmlmZXN0c18xNTA4MiI6eyJidWNrZXQiOiJ0cnVlX2JhY2tlbmQiLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X2xlZ2FjeV90aW1lbGluZSI6eyJidWNrZXQiOiJvZmYiLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X3R3ZWV0X2VkaXRfZnJvbnRlbmQiOnsiYnVja2V0Ijoib24iLCJ2ZXJzaW9uIjpudWxsfX0%3D&frame=false&hideBorder=false&hideFooter=false&hideHeader=false&hideScrollBar=false&lang=en&origin=https%3A%2F%2Fpublish.twitter.com&sessionId=c4d4d3ea6b7d1de8f5d4c54e79e9c6b4c5e4f5c6&showHeader=true&showReplies=false&transparent=false&widgetsVersion=2615f7e52b7e0%3A1702314776716`;
      }
    } catch (error) {
      console.error('Error creating embed URL for', platform, ':', error);
    }
    return '';
  };

    return (
      <div className="social-media-combined-container slide-in-animation">
        <div className="social-media-header fade-in-header">
          <div className="header-content">
            <div className="header-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
              </svg>
            </div>
            <h3>{name}</h3>
          </div>
          <div className="platform-badges">
            {platforms.map((platform, index) => (
              <span
                key={platform.platform}
                className="platform-badge"
                style={{
                  animationDelay: `${0.3 + (index * 0.1)}s`
                }}
              >
                {platform.platform.toUpperCase()}
              </span>
            ))}
          </div>
        </div>
        <div className={`social-media-grid ${platforms.length === 1 ? 'single-platform' : `multi-platform ${platforms.length === 2 ? 'two-platforms' : 'three-plus-platforms'}`}`}>
          {platforms.map((platform, index) => {
            const embedUrl = createEmbedUrl(platform.platform, platform.url, platforms.length);
            return (
              <div
                key={platform.platform}
                className="social-media-item"
                style={{
                  animationDelay: `${0.5 + (index * 0.2)}s`
                }}
              >
                <div className="platform-title">
                  <div className="platform-icon">
                    {platform.platform === 'facebook' && (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                    )}
                    {platform.platform === 'instagram' && (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    )}
                    {platform.platform === 'twitter' && (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                      </svg>
                    )}
                  </div>
                  <h4>{platform.name}</h4>
                </div>
                <div className="iframe-container">
                  <iframe
                    key={`${platform.platform}-${socialMediaAnimationKey}`}
                    src={embedUrl}
                    width="100%"
                    height={platforms.length === 1 ? "700" : platforms.length === 2 ? "600" : "500"}
                    frameBorder="0"
                    scrolling="no"
                    allowFullScreen
                    allow="autoplay; encrypted-media"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation"
                    title={platform.name}
                    loading="lazy"
                    style={{
                      opacity: 1,
                      transition: 'opacity 0.3s ease'
                    }}
                    onLoad={(e) => {
                      console.log(`${platform.platform} embed loaded successfully`);
                      // Hide loading overlay when iframe loads
                      const loadingOverlay = e.target.nextSibling;
                      if (loadingOverlay && loadingOverlay.classList.contains('loading-overlay')) {
                        loadingOverlay.style.opacity = '0';
                        setTimeout(() => {
                          loadingOverlay.style.display = 'none';
                        }, 300);
                      }
                    }}
                    onError={(e) => {
                      console.error(`Error loading ${platform.platform} embed:`, e);
                      // Keep loading overlay visible on error
                      const loadingOverlay = e.target.nextSibling;
                      if (loadingOverlay && loadingOverlay.classList.contains('loading-overlay')) {
                        loadingOverlay.innerHTML = `<p>Unable to load ${platform.name}</p>`;
                      }
                    }}
                  />
                  <div className="loading-overlay">
                    <div className="loading-spinner"></div>
                    <p>Loading {platform.name}...</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  useEffect(() => {
    let unsubscribeFunctions = [];

    const authUnsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (!currentUser) {
        signOut(getAuth());
        window.localStorage.removeItem("user");
        return;
      }
      const userDocRef = doc(db, "users", currentUser.uid);
      const userDoc = await getDoc(userDocRef);

      const fetchColumn1Data = async (user) => {
        const column1CollectionRef = collection(db, "users");
        const usersQuery = query(
          column1CollectionRef,
          where("agency", "==", user.agency)
        );
        const unsubscribeUsers = onSnapshot(usersQuery, (querySnapshot) => {
          const data = querySnapshot.docs.map((doc) => doc.data());
          const users = [];
          data.forEach((ele) => {
            if (ele.OndutyEMS || ele.OndutyFire) {
              users.push(ele);
            }
          });
          setColumn1Data(users);
        });
        unsubscribeFunctions.push(unsubscribeUsers);
      };

      const fetchUserData = async (userId) => {
        try {
          const userDocRef = doc(db, "users", userId);
          const userDoc = await getDoc(userDocRef);
          
          if (userDoc.exists() && userDoc.data()) {
            const userName = userDoc.data().name || "Unknown User";
            const userImg = userDoc.data().userImg || "";
            return { userName, userImg };
          } else {
            return { userName: "Unknown User", userImg: "" };
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          return { userName: "Unknown User", userImg: "" };
        }
      };

      const fetchColumn2Data = async (user) => {
        const currentTime = new Date();
        const oneHourAgo = new Date(currentTime);
        oneHourAgo.setHours(currentTime.getHours() - 1);
        const alarmsCollection = collection(db, user.agency);
        const alarmsQuery = query(alarmsCollection);
        const unsubscribeAlarms = onSnapshot(
          alarmsQuery,
          async (querySnapshot) => {
            const data = querySnapshot.docs.map((doc) => doc.data());
            const postsWithSeconds = data.filter(
              (post) => post.postTime && post.postTime.seconds
            );

            postsWithSeconds.sort((a, b) => {
              return b.postTime.seconds - a.postTime.seconds;
            });

            const postsWithAllowedPrivacy = postsWithSeconds.filter((post) => {
              const privacy = post.privacy;
              return !privacy || privacy === "All" || privacy === "stationboard";
            });

            // Limit to 5 most recent memos for better performance
            const limitedPosts = postsWithAllowedPrivacy.slice(0, 5);

            const postsWithUserData = await Promise.all(
              limitedPosts.map(async (post) => {
                const userData = await fetchUserData(post.userId);
                return { ...post, ...userData };
              })
            );

            setColumn2Data(postsWithUserData);
            setLastUpdated(new Date());
          }
        );
        unsubscribeFunctions.push(unsubscribeAlarms);
      };

      const deptCollection = await getDocs(
        collection(db, userDoc.data()["agency"] + " Station Board")
      );
      deptCollection.forEach((dept) => {
        if (dept.data()["when2work"]) {
          setShowW2W(true);
          getShifts(dept.data()["apiKey"], dept.data()["endPoint"]);
          setInterval(() => {
            getShifts(dept.data()["apiKey"], dept.data()["endPoint"]);
          }, 5 * 60 * 1000);
        } else {
          setShowW2W(false);
        }
      });

      // Store agency name for use in other useEffects
      setAgencyName(userDoc.data().agency);
      
      fetchColumn1Data(userDoc.data());
      fetchColumn2Data(userDoc.data());
      fetchWeatherAlerts();
      fetchRotationFiles(userDoc.data().agency, unsubscribeFunctions);
    });

    // Cleanup function
    return () => {
      unsubscribeFunctions.forEach(unsubscribe => {
        if (typeof unsubscribe === 'function') {
          unsubscribe();
        }
      });
    };
  }, []);

  // Effect to fetch agency settings (logo, description) for leadership themes
  useEffect(() => {
    if (!agencyName) return;

    const settingsDocRef = doc(db, `${agencyName} Settings`, 'Info');
    const unsubscribeSettings = onSnapshot(settingsDocRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        if (data?.logo) setAgencyLogo(data.logo);
        if (data?.description) setAgencyDescription(data.description);
        if (data?.name) setAgencyDisplayName(data.name);
      }
    }, (error) => {
      console.error('Error fetching agency settings for leadership:', error);
    });

    return () => unsubscribeSettings();
  }, [agencyName]);

  // Effect to fetch units based on unitDataSource setting
  useEffect(() => {
    if (!agencyName) return;

    let unsubscribeUnits = null;

    const fetchUnitsFromSource = () => {
      console.log('Fetching units from source:', unitDataSource, 'for agency:', agencyName);

      if (unitDataSource === 'fleet') {
        // Fetch from FleetTrack collection
        const fleetCollection = collection(db, `Agencies/${agencyName}/FleetTrack`);
        unsubscribeUnits = onSnapshot(fleetCollection, (querySnapshot) => {
          const fleetData = querySnapshot.docs.map(doc => {
            const data = doc.data();
            // Log the raw data to debug field names
            console.log('FleetTrack raw data:', doc.id, data);
            
            // Check for status field (lowercase)
            const statusValue = data.status || data.Status || 'Unknown';
            const statusLower = statusValue.toLowerCase();
            
            return {
              id: doc.id,
              name: data.unitNumber || data.UnitNumber || data.name || 'Unknown Unit',
              status: statusValue,
              type: data.type || data.Type || '',
              // Normalize status for filtering and display (case-insensitive)
              isRetired: statusLower === 'retired',
              disabledService: statusLower === 'out of service',
              underMaintenance: statusLower === 'under maintenance',
              inService: statusLower === 'in service',
              dataSource: 'fleet'
            };
          });
          // Filter out retired units
          const filteredUnits = fleetData.filter(unit => !unit.isRetired);
          console.log('FleetTrack units loaded:', filteredUnits.length, filteredUnits);
          setUnits(filteredUnits);
        });
      } else if (unitDataSource === 'units') {
        // Fetch from units collection
        const unitsCollection = collection(db, `Agencies/${agencyName}/units`);
        unsubscribeUnits = onSnapshot(unitsCollection, (querySnapshot) => {
          const unitsData = querySnapshot.docs
            .map(doc => {
              const data = doc.data();
              return {
                id: doc.id,
                name: data.name || 'Unknown Unit',
                type: data.type || '',
                // Convert boolean inService to status format
                disabledService: data.inService === false,
                inService: data.inService === true,
                status: data.inService ? 'In Service' : 'Out of Service',
                mutual: data.mutual || false,
                order: data.order != null ? data.order : null,
                dataSource: 'units'
              };
            })
            .filter(unit => !unit.mutual)
            .sort((a, b) => {
              if (a.order != null && b.order != null) return String(a.order).localeCompare(String(b.order), undefined, { numeric: true });
              if (a.order != null) return -1;
              if (b.order != null) return 1;
              return 0;
            });
          console.log('Units collection loaded:', unitsData.length);
          setUnits(unitsData);
        });
      } else {
        // Default: Fetch from Rigchecks (original behavior)
        const rigchecksCollection = collection(db, `Rigchecks/VgTv80ik2BtavT0A5owc/${agencyName} Rigchecks`);
        unsubscribeUnits = onSnapshot(rigchecksCollection, (querySnapshot) => {
          const rigcheckData = querySnapshot.docs.map(doc => {
            const data = doc.data();
            return {
              ...data,
              id: doc.id,
              dataSource: 'rigcheck'
            };
          });
          // Filter out units where isChildCheck is true
          const filteredUnits = rigcheckData.filter(unit => !unit.isChildCheck);
          console.log('Rigcheck units loaded:', filteredUnits.length);
          setUnits(filteredUnits);
        });
      }
    };

    fetchUnitsFromSource();

    // Cleanup function
    return () => {
      if (unsubscribeUnits && typeof unsubscribeUnits === 'function') {
        unsubscribeUnits();
      }
    };
  }, [agencyName, unitDataSource]);

  // State to track PDF page navigation
  const [currentPdfPage, setCurrentPdfPage] = useState(1);
  const [pdfTotalPages, setPdfTotalPages] = useState(1);

    // Effect to handle rotation file cycling
    useEffect(() => {
        // Only run when in rotation view with items to display
        if (currentView !== "rotation" || combinedRotationItems.length === 0) {
            return;
        }

        // Get current item
        const currentItem = combinedRotationItems[currentRotationIndex];

        // Default durations based on content type
        let defaultDuration;
        if (currentItem.type === 'social-combined') {
            defaultDuration = 20; // 20 seconds for social media
        } else if (currentItem.type === 'calendar') {
            defaultDuration = 30; // 30 seconds for Google Calendar embed
        } else {
            defaultDuration = 10; // 10 seconds for everything else (PDFs, images)
        }

        // Use duration from item if available, otherwise use default
        const itemDuration = currentItem.duration || defaultDuration;

        console.log(`Setting up rotation for item ${currentRotationIndex}, duration: ${itemDuration}s`);

        // Initialize the countdown
        setTotalDuration(itemDuration);
        setCountdownSeconds(itemDuration);

        // Set up the countdown interval - updates every second
        const countdownInterval = setInterval(() => {
            setCountdownSeconds(prevSeconds => {
                // Reduce by 1 each second, but don't go below 0
                return Math.max(0, prevSeconds - 1);
            });
        }, 1000);

        // Set up the item rotation timeout
        const rotationTimeout = setTimeout(() => {
            // Check if current item is a PDF
            const fileUrl = currentItem?.url || currentItem;
            const isPdf = typeof fileUrl === 'string' && (
                fileUrl.toLowerCase().includes('.pdf') ||
                fileUrl.toLowerCase().includes('application/pdf') ||
                fileUrl.toLowerCase().includes('pdf%')
            );

            if (isPdf && pdfTotalPages > 1 && currentPdfPage < pdfTotalPages) {
                // Navigate to next PDF page
                setCurrentPdfPage(prevPage => prevPage + 1);
            } else {
                // Move to next rotation item
                setCurrentPdfPage(1);
                setCurrentRotationIndex(prevIndex => (prevIndex + 1) % combinedRotationItems.length);
            }
        }, itemDuration * 1000);

        // Clean up intervals and timeouts when component unmounts or dependencies change
        return () => {
            clearInterval(countdownInterval);
            clearTimeout(rotationTimeout);
        };
    }, [currentView, combinedRotationItems, currentRotationIndex, pdfTotalPages, currentPdfPage]);



    // Effect to combine rotation files and social media items
    useEffect(() => {
        console.log('Combining rotation items...');
        const combined = [];

        // Add file rotation items
        rotationFiles.forEach((file, index) => {
            // Preserve duration if it exists
            combined.push({
                ...file,
                type: 'file'
                // Keep original duration if present
            });
        });

        // Add social media items
        socialMediaItems.forEach((socialItem, index) => {
            combined.push({
                ...socialItem,
                // Don't set a default duration here, will handle in rotation effect
            });
        });

        // Add Google Calendar item if enabled and URL is provided
        if (googleCalendar && googleCalendarUrl) {
            const calendarItem = {
                type: 'calendar',
                url: googleCalendarUrl,
                name: 'Department Calendar'
                // Don't set a default duration here, will handle in rotation effect
            };
            combined.push(calendarItem);
        }

        // Department Calendar is now shown as a standalone view in main rotation
        // No need to add it to combinedRotationItems
        console.log('Department Calendar (standalone view):', {
            departmentCalendar,
            eventsCount: departmentCalendarEvents.length,
            willShowInMainRotation: departmentCalendar && departmentCalendarEvents.length > 0
        });

        console.log('Combined rotation items total:', combined.length);

        // Check if combined items actually changed
        const currentCombinedString = JSON.stringify(combinedRotationItems);
        const newCombinedString = JSON.stringify(combined);

        if (currentCombinedString !== newCombinedString) {
            // Only update if there's an actual change
            setCombinedRotationItems(combined);

            // Reset rotation index if needed
            if (currentRotationIndex >= combined.length && combined.length > 0) {
                setCurrentRotationIndex(0);
            }
        }
    }, [rotationFiles, socialMediaItems, googleCalendar, googleCalendarUrl, departmentCalendar, departmentCalendarEvents]);

  useEffect(() => {
    let intervalId;
    if (selectedTab === "dashboard") {
      // Initialize countdown for non-rotation screens
      if (currentView !== "rotation" && currentView !== "departmentCalendar") {
        setTotalDuration(30);
        setCountdownSeconds(30);
      } else if (currentView === "departmentCalendar") {
        setTotalDuration(30);
        setCountdownSeconds(30);
      }

      // Set up rotation interval
      intervalId = setInterval(() => {
        setCurrentView((prevView) => {
          if (prevView === "memos") {
            // Check if duty crew screen is enabled (show if enabled regardless of data)
            if (dutyCrewScreen) {
              return "dutyCrews";
            }
            return "unitStatus";
          }
          if (prevView === "dutyCrews") return "unitStatus";
          if (prevView === "unitStatus" && combinedRotationItems.length > 0) {
            // Refresh social media animation key when entering rotation view
            setSocialMediaAnimationKey(prev => prev + 1);
            return "rotation"; // Show rotation items after unit status if available
          }
          if (prevView === "rotation" || (prevView === "unitStatus" && combinedRotationItems.length === 0)) {
            // Check if department calendar is enabled
            if (departmentCalendar && departmentCalendarEvents.length > 0) {
              return "departmentCalendar";
            }
            // Check if leadership screen is enabled
            if (leadershipScreen && leadershipData.length > 0) {
              return "leadership";
            } else {
              // Fetch weather alerts when switching to NEXRAD view
              fetchWeatherAlerts();
              return "NEXRAD";
            }
          }
          if (prevView === "departmentCalendar") {
            // Check if leadership screen is enabled
            if (leadershipScreen && leadershipData.length > 0) {
              return "leadership";
            } else {
              // Fetch weather alerts when switching to NEXRAD view
              fetchWeatherAlerts();
              return "NEXRAD";
            }
          }
          if (prevView === "leadership") {
            // Fetch weather alerts when switching to NEXRAD view
            fetchWeatherAlerts();
            return "NEXRAD";
          }
          return "memos"; // Go back to memos after NEXRAD
        });
        // Reset countdown for non-rotation screens when view changes
        setCountdownSeconds(30);
      }, 30000); // Rotate view every 30 seconds
    }

    // Cleanup function
    return () => clearInterval(intervalId);
  }, [selectedTab, combinedRotationItems.length, leadershipScreen, leadershipData.length, departmentCalendar, departmentCalendarEvents.length, currentView, dutyCrewScreen]);

  // Cycle through unit subpages every 10 seconds while on unitStatus view
  useEffect(() => {
    if (currentView !== "unitStatus") {
      setUnitSubPage(0);
      return;
    }
    const filteredCount = units.filter(unit => {
      if (unit.dataSource === 'rigcheck') return /\d/.test(unit.name) && !unit.disabled;
      return true;
    }).length;
    const totalSubPages = Math.max(1, Math.ceil(filteredCount / 15));
    if (totalSubPages <= 1) return;

    const subPageInterval = setInterval(() => {
      setUnitSubPage(prev => (prev + 1) % totalSubPages);
    }, 10000);

    return () => clearInterval(subPageInterval);
  }, [currentView, units]);

  // Auto-scroll duty crews container
  useEffect(() => {
    if (currentView !== "dutyCrews") return;
    const container = dutyCrewScrollRef.current;
    if (!container) return;

    // Reset scroll to top when entering view
    container.scrollTop = 0;
    let scrollDown = true;

    const scrollInterval = setInterval(() => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const maxScroll = scrollHeight - clientHeight;
      if (maxScroll <= 0) return; // nothing to scroll

      if (scrollDown) {
        container.scrollTop = Math.min(scrollTop + 1, maxScroll);
        if (container.scrollTop >= maxScroll) scrollDown = false;
      } else {
        container.scrollTop = Math.max(scrollTop - 1, 0);
        if (container.scrollTop <= 0) scrollDown = true;
      }
    }, 100);

    return () => clearInterval(scrollInterval);
  }, [currentView]);

  // Countdown timer for non-rotation screens (including departmentCalendar)
  useEffect(() => {
    let countdownInterval;
    if (selectedTab === "dashboard" && currentView !== "rotation") {
      countdownInterval = setInterval(() => {
        setCountdownSeconds(prevSeconds => {
          return Math.max(0, prevSeconds - 1);
        });
      }, 1000);
    }

    return () => clearInterval(countdownInterval);
  }, [selectedTab, currentView]);

  // Fetch weather alerts initially if view is NEXRAD
  useEffect(() => {
    if (currentView === "NEXRAD") {
      fetchWeatherAlerts();
    }
  }, [currentView]);

  useEffect(() => {
    const scrollColumns = () => {
      if (column1Ref.current) {
        const column1 = column1Ref.current;
        const canScrollColumn1 = column1.scrollHeight > column1.clientHeight;
        if (canScrollColumn1) {
          column1.scrollTop += scrollDirection * 1;
        }
        if (
          column1.scrollTop === 0 ||
          column1.scrollTop + column1.clientHeight >= column1.scrollHeight
        ) {
          setScrollDirection(scrollDirection === 1 ? -1 : 1);
        }
      }
      if (column2Ref.current) {
        const column2 = column2Ref.current;
        const canScrollColumn2 = column2.scrollHeight > column2.clientHeight;
        if (canScrollColumn2) {
          column2.scrollTop += scrollDirection * 1;
        }
        if (
          column2.scrollTop === 0 ||
          column2.scrollTop + column2.clientHeight >= column2.scrollHeight
        ) {
          setScrollDirection(scrollDirection === 1 ? -1 : 1);
        }
      }
    };
    const intervalId = setInterval(scrollColumns, 100);
    return () => {
      clearInterval(intervalId);
    };
  }, [scrollDirection]);

  useEffect(() => {
    const checkDarkMode = () => {
      const currentHour = new Date().getHours();
      setIsDarkMode(currentHour < 8 || currentHour >= 17);
    };
    checkDarkMode();
    const intervalId = setInterval(checkDarkMode, 60000);
    return () => clearInterval(intervalId);
  }, []);

  const getShifts = async (api, endPoint) => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    const tomorrow = new Date(currentDate);
    tomorrow.setDate(currentDate.getDate() + 1);
    const yearTomorrow = tomorrow.getFullYear();
    const monthTomorrow = String(tomorrow.getMonth() + 1).padStart(2, "0");
    const dayTomorrow = String(tomorrow.getDate()).padStart(2, "0");

    const getDateTomorrow = `${monthTomorrow}/${dayTomorrow}/${yearTomorrow}`;
    console.log("Fetching data from When2Work API for tomorrow:", getDateTomorrow);

    const getDate = `${month}/${day}/${year}`;
    console.log("Fetching data from When2Work API for date:", getDate);
    let resp = await fetch(
      endPoint + getDate + "&end_date=" + getDateTomorrow + "&key=" + api
    );
    console.log(resp);
    let data = await resp.json();
    console.log("Data from When2Work API:", data);
    splitEventsByTime(data.AssignedShiftList);
    setLastUpdated(new Date());
  };

  const splitEventsByTime = (events) => {
    const currentTime = new Date();
    const tomorrow = new Date(currentTime);
    tomorrow.setDate(currentTime.getDate() + 1);

    const onToday = [];
    const onTomorrow = [];

    events.forEach((event) => {
      const startDateParts = event.START_DATE.split("/");
      const endDateParts = event.END_DATE.split("/");
      const startTimeParts = event.START_TIME.match(/(\d+)(\w+)/);

      if (
        startDateParts.length === 3 &&
        endDateParts.length === 3 &&
        startTimeParts
      ) {
        const startMonth = parseInt(startDateParts[0]) - 1;
        const startDay = parseInt(startDateParts[1]);
        const startYear = parseInt(startDateParts[2]);

        const startHour = parseInt(startTimeParts[1]);
        const startAmPm = startTimeParts[2];

        const startDateTime = new Date(
          startYear,
          startMonth,
          startDay,
          startAmPm === "pm" ? startHour + 12 : startHour,
          0
        );

        if (
          startDateTime.getDate() === currentTime.getDate() &&
          startDateTime.getMonth() === currentTime.getMonth() &&
          startDateTime.getFullYear() === currentTime.getFullYear()
        ) {
          onToday.push(event);
        } else if (
          startDateTime.getDate() === tomorrow.getDate() &&
          startDateTime.getMonth() === tomorrow.getMonth() &&
          startDateTime.getFullYear() === tomorrow.getFullYear()
        ) {
          onTomorrow.push(event);
        }
      }
    });

    const onNowLeft = [];
    const onNowRight = [];
    const onLaterLeft = [];
    const onLaterRight = [];

    onToday.forEach((event, index) => {
      if (index % 2 === 0) {
        onNowLeft.push(event);
      } else {
        onNowRight.push(event);
      }
    });

    onTomorrow.forEach((event, index) => {
      if (index % 2 === 0) {
        onLaterLeft.push(event);
      } else {
        onLaterRight.push(event);
      }
    });

    setOnNowLeft(onNowLeft);
    setOnNowRight(onNowRight);
    setOnLaterLeft(onLaterLeft);
    setOnLaterRight(onLaterRight);
  };

  return (
    <div
      className={`dashboard ${selectedTab === "map" ? "hide" : "show"} ${
        isDarkMode ? "dark-mode" : ""
      } ${currentView === "NEXRAD" ? "nexrad-fullwidth" : ""}`}
    >
      {currentView === "rotation" && combinedRotationItems.length > 0 ? (
        <div className="dashboardColumn full-width-column">
          <h2>Station Information</h2>
          <div className="rotationContainer full-width-content" style={{ height: '80vh', marginBottom: '20px' }}>
            {combinedRotationItems.length > 0 ? (() => {
              const currentItem = combinedRotationItems[currentRotationIndex];
              const itemType = currentItem?.type || 'file';

              console.log('Current rotation item:', {
                index: currentRotationIndex,
                item: currentItem,
                type: itemType
              });

              // Handle social media items
              if (itemType === 'social-combined') {
                return renderSocialMediaEmbed(currentItem);
              }

              // Handle Google calendar items (iframe embed)
              if (itemType === 'calendar') {
                return (
                  <div className="calendar-container" style={{ width: '100%', height: '100%', position: 'relative' }}>
                    <iframe
                      src={currentItem.url}
                      width="100%"
                      height="100%"
                      style={{
                        display: 'block',
                        border: 'none',
                        maxWidth: '100%',
                        maxHeight: '100%'
                      }}
                      frameBorder="0"
                      title={currentItem.name || 'Department Calendar'}
                    />

                    {/* Calendar info overlay */}
                    <div className="calendar-info" style={{
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      background: 'rgba(0,0,0,0.6)',
                      color: 'white',
                      padding: '8px 15px',
                      borderRadius: '4px',
                      fontSize: '1.1rem',
                      opacity: 0.95,
                      zIndex: 10
                    }}>
                      📅 {currentItem.name || 'Department Calendar'}
                    </div>
                  </div>
                );
              }

              // Handle file items (PDFs and images)
              const fileUrl = currentItem?.url || currentItem;
              const fileName = currentItem?.name || `Rotation item ${currentRotationIndex + 1}`;

              // Improved PDF detection logic
              let isPdf = false;
              if (typeof fileUrl === 'string') {
                // Check URL for PDF extension or content
                isPdf = fileUrl.toLowerCase().includes('.pdf') ||
                        fileUrl.toLowerCase().includes('application/pdf') ||
                        fileUrl.toLowerCase().includes('pdf%');
              }

              console.log('File detection:', {
                url: fileUrl,
                isPdf: isPdf
              });

              // Process PDF URL to hide UI elements if possible
              let pdfViewerUrl = fileUrl;
              // Add parameters to hide UI elements if it's a direct PDF URL
              if (typeof fileUrl === 'string' && !fileUrl.includes('#')) {
                pdfViewerUrl = `${fileUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&view=Fit`;
              }

              return isPdf ? (
                <div className="pdf-container" style={{ width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }}>
                  {/* PDF viewer optimized for non-interactive TV display */}
                  <iframe
                    src={pdfViewerUrl}
                    width="100%"
                    height="100%"
                    style={{
                      display: 'block',
                      border: 'none',
                      maxWidth: '100%',
                      maxHeight: '100%',
                      margin: 'auto'
                    }}
                    frameBorder="0"
                    title={fileName}
                  />

                  {/* PDF TV mode indicator with file name */}
                  <div className="pdf-info" style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    background: 'rgba(0,0,0,0.6)',
                    color: 'white',
                    padding: '8px 15px',
                    borderRadius: '4px',
                    fontSize: '1.1rem',
                    opacity: 0.95,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    maxWidth: '80%',
                    zIndex: 10
                  }}>
                    <div className="pdf-filename" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                      {fileName}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="image-debug-container" style={{ position: 'relative', width: '100%', height: '100%' }}>
                  <img
                    src={fileUrl}
                    alt={fileName}
                    className="rotation-image"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      display: 'block'
                    }}
                    onLoad={() => {
                      console.log('Image loaded successfully:', fileUrl);
                    }}
                    onError={(e) => {
                      console.error('Image failed to load:', fileUrl);
                      console.error('Error details:', e);
                    }}
                  />
                </div>
              );
            })() : (
              <div className="no-rotation-items">Loading content...</div>
            )}
          </div>
        </div>
      ) : currentView === "NEXRAD" ? (
        // Full-width NEXRAD view that spans both columns
        <div className="dashboardColumn full-width-column nexrad-container">
          <h2>RADAR</h2>
          <div className="nexrad-content-wrapper">
            <div className="mapContainer full-width-map">
              <iframe
                src="https://radar.weather.gov/?settings=v1_eyJhZ2VuZGEiOnsiaWQiOiJ3ZWF0aGVyIiwiY2VudGVyIjpbLTcyLjY4NSw0MC45NF0sImxvY2F0aW9uIjpbLTcyLjY4NSw0MC45NF0sInpvb20iOjksImxheWVyIjoiY3JlZl9xY2QifSwiYW5pbWF0aW5nIjp0cnVlLCJiYXNlIjoic2F0ZWxsaXRlIiwiYXJ0Y2MiOnRydWUsImNvdW50eSI6dHJ1ZSwiY3dhIjp0cnVlLCJyZmMiOnRydWUsInN0YXRlIjpmYWxzZSwibWVudSI6dHJ1ZSwic2hvcnRGdXNlZE9ubHkiOmZhbHNlLCJvcGFjaXR5Ijp7ImFsZXJ0cyI6MC44LCJsb2NhbCI6MC42LCJsb2NhbFN0YXRpb25zIjowLjgsIm5hdGlvbmFsIjowLjZ9fQ%3D%3D"
                width="100%"
                height="100%"
                frameBorder="0"
                title="NOAA Weather Radar"
                allowFullScreen
              />
            </div>

            <div className="weatherAlerts">
              <h3>Weather Alerts</h3>
              <div className="alerts-container">
                <ul className="alerts-list">
                  {weatherAlerts.length > 0 ? (
                    weatherAlerts.map((alert, index) => (
                      <li key={index} className="alert-item">
                        <strong>{alert.properties.event}</strong>: {alert.properties.headline}
                      </li>
                    ))
                  ) : (
                    <li>No active weather alerts.</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      ) : currentView === "leadership" ? (
        // Leadership view - Full width display, theme-aware
        (() => {
          const theme = leadershipTheme || 'classicRed';
          // Normalize a numeric-ish field (number or numeric string) to a number, else null.
          const numLevel = (v) => {
            if (typeof v === 'number') return Number.isNaN(v) ? null : v;
            if (typeof v === 'string' && v.trim() !== '') {
              const n = parseFloat(v);
              return Number.isNaN(n) ? null : n;
            }
            return null;
          };
          // Infer a rank tier from the title when no explicit level is set.
          const inferLevel = (title) => {
            const t = String(title ?? '').toLowerCase();
            if (t.includes('chief')) return /\b(asst|assistant|deputy)\b/.test(t) ? 1 : 0;
            if (t.includes('captain') || /\bcapt\b/.test(t)) return 2;
            if (t.includes('lieutenant') || /\b(lt|lieut)\b/.test(t)) return 3;
            return null;
          };
          const effLevel = (l) => {
            const lv = numLevel(l.level);
            return lv != null ? lv : inferLevel(l.title);
          };
          // Order by explicit display `order` when present, otherwise by rank tier so the
          // highest ranks come first; unknowns sort last. NaN-safe.
          const sortVal = (l) => {
            const o = numLevel(l.order);
            if (o != null) return o;
            const lv = effLevel(l);
            return lv != null ? lv : 99;
          };
          const sortedLeadership = [...leadershipData].sort((a, b) => sortVal(a) - sortVal(b));

          // Classic Red theme: logo + dept name on left, photo grid on right
          if (theme === 'classicRed') {
            const renderPortrait = (leader, index) => (
              <div key={leader.id || index} className="lt-red-portrait">
                <div className="lt-red-photo">
                  {leader.image ? (
                    <img
                      src={leader.image}
                      alt={leader.title}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                  ) : null}
                  <div className="lt-red-placeholder" style={{ display: leader.image ? 'none' : 'flex' }}>
                    <svg viewBox="0 0 100 110" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <circle cx="50" cy="35" r="22" fill="currentColor" />
                      <path d="M10 110 C 10 75, 30 65, 50 65 C 70 65, 90 75, 90 110 Z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div className="lt-red-caption">
                  <div className="lt-red-title">{leader.title}</div>
                  {leader.name && <div className="lt-red-name">{leader.name}</div>}
                </div>
              </div>
            );

            // Fixed layout to match the design: 3 across, then 3 across, then the rest
            // (4 or more) on the third row. The rank-aware sort above decides who lands
            // where, so the top ranks fill row 1, the next 3 fill row 2, and so on.
            const rowTop = sortedLeadership.slice(0, 3);
            const rowMid = sortedLeadership.slice(3, 6);
            const rowBot = sortedLeadership.slice(6);

            return (
              <div className="lt-red-container">
                <div className="lt-red-stage">
                  <div className="lt-red-brand">
                    <h1 className="lt-red-heading">Our Chiefs &amp; Officers</h1>
                    <div className="lt-red-brand-body">
                      {agencyLogo && (
                        <img src={agencyLogo} alt={agencyDisplayName || 'Agency Logo'} className="lt-red-logo" />
                      )}
                      {(agencyDisplayName || agencyName) && (
                        <div className="lt-red-dept-name">{agencyDisplayName || agencyName}</div>
                      )}
                      {agencyDescription && (
                        <div className="lt-red-tagline">{agencyDescription}</div>
                      )}
                    </div>
                  </div>
                  <div className="lt-red-grid">
                    {rowTop.length > 0 && (
                      <div className="lt-red-row lt-red-row-top">
                        {rowTop.map((leader, i) => renderPortrait(leader, i))}
                      </div>
                    )}
                    {rowMid.length > 0 && (
                      <div className="lt-red-row lt-red-row-mid">
                        {rowMid.map((leader, i) => renderPortrait(leader, i))}
                      </div>
                    )}
                    {rowBot.length > 0 && (
                      <div className="lt-red-row lt-red-row-bot">
                        {rowBot.map((leader, i) => renderPortrait(leader, i))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          }

          // Themes that share the hierarchy structure: classicBlue, modernDark, modernLight
          const renderLeadershipCard = (leader, index, size = 'normal') => (
            <div key={leader.id || index} className={`leadership-card ${size}`}>
              <div className="leadership-image-container">
                {leader.image ? (
                  <img
                    src={leader.image}
                    alt={leader.title}
                    className="leadership-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}
                <div className="leadership-placeholder" style={{ display: leader.image ? 'none' : 'flex' }}>
                  <AccountCircleIcon style={{ fontSize: size === 'large' ? '90px' : size === 'medium' ? '75px' : '65px', color: '#ccc' }} />
                </div>
              </div>
              <div className="leadership-info">
                <h3 className="leadership-title">{leader.title}</h3>
                {leader.name && (
                  <p className="leadership-name">{leader.name}</p>
                )}
              </div>
            </div>
          );

          return (
            <div className={`dashboardColumn full-width-column leadership-container leadership-theme-${theme}`}>
              <h2>Department Leadership</h2>
              <div className="leadership-content">
                <div className="leadership-hierarchy">
                  {sortedLeadership.length > 0 && (
                    <div className="leadership-row row-1">
                      {renderLeadershipCard(sortedLeadership[0], 0, 'large')}
                    </div>
                  )}

                  {sortedLeadership.length > 1 && (
                    <div className="leadership-row row-2">
                      {sortedLeadership.slice(1, 4).map((leader, index) =>
                        renderLeadershipCard(leader, index + 1, 'medium')
                      )}
                    </div>
                  )}

                  {sortedLeadership.length > 4 && (
                    <div className="leadership-row row-3">
                      {sortedLeadership.slice(4, 10).map((leader, index) =>
                        renderLeadershipCard(leader, index + 4, 'normal')
                      )}
                    </div>
                  )}

                  {sortedLeadership.length > 10 && (
                    <div className="leadership-row row-4">
                      {sortedLeadership.slice(10).map((leader, index) =>
                        renderLeadershipCard(leader, index + 10, 'normal')
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })()
      ) : currentView === "departmentCalendar" ? (
        // Department Calendar view - Full width display
        <div className={`dashboardColumn full-width-column department-calendar-view ${isDarkMode ? 'dark-mode' : ''}`}>
          <h2>Department Calendar</h2>
          <div className="department-calendar-wrapper" style={{
            height: 'calc(100vh - 120px)',
            overflowY: 'auto',
            padding: '20px',
            backgroundColor: isDarkMode ? '#1a1a1a' : '#f5f5f5'
          }}>
            {(() => {
              const events = departmentCalendarEvents || [];
              const today = new Date();
              const nextWeek = new Date(today.getTime() + 14 * 24 * 60 * 60 * 1000); // Next 2 weeks
              
              // Filter upcoming events within next 2 weeks
              const upcomingEvents = events
                .filter(event => {
                  const eventStart = new Date(event.startDate);
                  return eventStart >= today && eventStart <= nextWeek;
                })
                .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

              // Helper function to get event type color
              const getEventTypeColor = (type) => {
                const colors = {
                  meeting: '#1976d2',
                  training: '#d32f2f',
                  event: '#388e3c',
                  standby: '#f57c00',
                  other: '#757575'
                };
                return colors[type] || colors.other;
              };

              // Helper function to format date
              const formatDate = (date) => {
                const d = new Date(date);
                const options = { weekday: 'short', month: 'short', day: 'numeric' };
                return d.toLocaleDateString('en-US', options);
              };

              // Helper function to format time
              const formatTime = (event) => {
                if (event.allDay) return 'All Day';
                const start = new Date(event.startDate);
                const end = new Date(event.endDate);
                return `${start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })} - ${end.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`;
              };

              return (
                <div style={{
                  maxWidth: '1600px',
                  margin: '0 auto'
                }}>
                  {/* Header - Ultra Compact */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '15px',
                    paddingBottom: '12px',
                    borderBottom: '2px solid #e53e3e'
                  }}>
                    <div style={{
                      fontSize: '32px'
                    }}>📅</div>
                    <div>
                      <h2 style={{
                        margin: 0,
                        fontSize: '1.8rem',
                        color: '#e53e3e',
                        fontWeight: 'bold'
                      }}>Upcoming Events</h2>
                      <p style={{
                        margin: '2px 0 0 0',
                        fontSize: '0.95rem',
                        color: isDarkMode ? '#aaa' : '#666'
                      }}>Next 2 Weeks ({upcomingEvents.length} event{upcomingEvents.length !== 1 ? 's' : ''})</p>
                    </div>
                  </div>

                  {/* Events List - Ultra Compact for Display Screen */}
                  {upcomingEvents.length > 0 ? (
                    <div style={{
                      backgroundColor: isDarkMode ? '#2a2a2a' : 'white',
                      borderRadius: '8px',
                      boxShadow: isDarkMode ? '0 1px 4px rgba(0,0,0,0.3)' : '0 1px 4px rgba(0,0,0,0.1)',
                      overflow: 'hidden'
                    }}>
                      {upcomingEvents.map((event, index) => (
                        <div key={event.id || index} style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '8px 12px',
                          borderBottom: index < upcomingEvents.length - 1 ? (isDarkMode ? '1px solid #444' : '1px solid #e0e0e0') : 'none',
                          borderLeft: `4px solid ${getEventTypeColor(event.type)}`,
                          animation: `fadeIn 0.2s ease-in-out ${index * 0.02}s both`,
                          backgroundColor: isDarkMode ? '#2a2a2a' : 'transparent'
                        }}>
                          {/* Date Column - Compact */}
                          <div style={{
                            minWidth: '90px',
                            marginRight: '12px',
                            textAlign: 'center',
                            padding: '4px 6px',
                            backgroundColor: isDarkMode ? '#3a3a3a' : '#f5f5f5',
                            borderRadius: '6px'
                          }}>
                            <div style={{
                              fontSize: '1.1rem',
                              fontWeight: 'bold',
                              color: '#e53e3e',
                              lineHeight: '1.1'
                            }}>
                              {new Date(event.startDate).getDate()}
                            </div>
                            <div style={{
                              fontSize: '0.7rem',
                              color: isDarkMode ? '#aaa' : '#666',
                              textTransform: 'uppercase'
                            }}>
                              {new Date(event.startDate).toLocaleDateString('en-US', { month: 'short' })}
                            </div>
                          </div>

                          {/* Event Details Column - Single Line */}
                          <div style={{ 
                            flex: 1, 
                            minWidth: 0,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                          }}>
                            {/* Type Badge */}
                            <span style={{
                              backgroundColor: getEventTypeColor(event.type),
                              color: 'white',
                              padding: '2px 8px',
                              borderRadius: '10px',
                              fontSize: '0.65rem',
                              fontWeight: '500',
                              textTransform: 'uppercase',
                              flexShrink: 0
                            }}>
                              {event.type || 'other'}
                            </span>
                            
                            {/* Title */}
                            <div style={{
                              fontSize: '1.05rem',
                              color: isDarkMode ? '#e0e0e0' : '#333',
                              fontWeight: '600',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              flex: 1
                            }}>{event.title}</div>

                            {/* Time */}
                            <div style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              gap: '4px',
                              fontSize: '1rem',
                              color: isDarkMode ? '#aaa' : '#666',
                              flexShrink: 0,
                              fontWeight: '500'
                            }}>
                              <span style={{ fontSize: '1rem' }}>🕐</span>
                              <span>{formatTime(event)}</span>
                            </div>

                            {/* Location */}
                            {event.location && (
                              <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '4px',
                                fontSize: '0.85rem',
                                color: isDarkMode ? '#aaa' : '#666',
                                maxWidth: '200px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                flexShrink: 0
                              }}>
                                <span style={{ fontSize: '0.9rem' }}>📍</span>
                                <span>{event.location}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{
                      textAlign: 'center',
                      padding: '60px 20px',
                      backgroundColor: isDarkMode ? '#2a2a2a' : 'white',
                      borderRadius: '12px',
                      boxShadow: isDarkMode ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                      <div style={{ fontSize: '64px', marginBottom: '20px' }}>📅</div>
                      <h3 style={{ color: isDarkMode ? '#aaa' : '#666', fontSize: '1.5rem', margin: 0 }}>
                        No Upcoming Events
                      </h3>
                      <p style={{ color: isDarkMode ? '#888' : '#999', fontSize: '1.1rem', marginTop: '10px' }}>
                        Check back later for scheduled events
                      </p>
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        </div>
      ) : currentView === "dutyCrews" ? (
        // Duty Crews view - Full width display with auto-scroll
        <div className={`dashboardColumn full-width-column duty-crews-view ${isDarkMode ? 'dark-mode' : ''}`}>
          <h2>Duty Crews</h2>
          <div className="duty-crews-container" ref={dutyCrewScrollRef} style={{
            height: 'calc(100vh - 120px)',
            overflowY: 'hidden',
            padding: '20px',
            backgroundColor: '#111921'
          }}>
            <div style={{ maxWidth: '1600px', margin: '0 auto' }}>

              {/* App Users On Duty Section */}
              {column1Data.length > 0 && (
                <div className="duty-section" style={{
                  marginBottom: '30px',
                  background: 'linear-gradient(135deg, #1f3652 0%, #12202e 100%)',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid #2a4a6b',
                  boxShadow: '0 3px 10px rgba(0, 0, 0, 0.3)'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '20px',
                    paddingBottom: '15px',
                    borderBottom: `2px solid #4a9eff`
                  }}>
                    <h3 style={{
                      margin: 0,
                      fontSize: '1.6rem',
                      color: '#4a9eff',
                      fontWeight: 'bold'
                    }}>Currently On Duty</h3>
                  </div>

                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '15px'
                  }}>
                    {column1Data.map((item, index) => (
                      <div key={index} style={{
                        background: 'linear-gradient(135deg, #12202e 0%, #0d1520 100%)',
                        borderRadius: '8px',
                        padding: '15px',
                        borderLeft: '4px solid #4a9eff',
                        border: '1px solid #2a4a6b',
                        transition: 'transform 0.2s'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          marginBottom: '10px'
                        }}>
                          <AccountCircleIcon style={{
                            fontSize: '40px',
                            color: '#4a9eff'
                          }} />
                          <div style={{ flex: 1 }}>
                            <div style={{
                              fontSize: '1.1rem',
                              fontWeight: '600',
                              color: 'white',
                              marginBottom: '2px'
                            }}>{item.name}</div>
                            <div style={{
                              fontSize: '0.9rem',
                              color: '#cccccc',
                              fontWeight: '500'
                            }}>{item.position}</div>
                          </div>
                        </div>
                        {item.onDutyTillstring && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '0.85rem',
                            color: '#999999',
                            marginTop: '8px',
                            paddingTop: '8px',
                            borderTop: '1px solid #2a4a6b'
                          }}>
                            <span>On Duty Until: {item.onDutyTillstring}</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* When2Work Schedule Section */}
              {showW2W && (
                <>
                  {/* Today's Schedule */}
                  {(onNowLeft.length > 0 || onNowRight.length > 0) && (
                    <div className="duty-section" style={{
                      marginBottom: '30px',
                      background: 'linear-gradient(135deg, #1f3652 0%, #12202e 100%)',
                      borderRadius: '12px',
                      padding: '20px',
                      border: '1px solid #2a4a6b',
                      boxShadow: '0 3px 10px rgba(0, 0, 0, 0.3)'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '20px',
                        paddingBottom: '15px',
                        borderBottom: `2px solid #4a9eff`
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <h3 style={{
                            margin: 0,
                            fontSize: '1.6rem',
                            color: '#4a9eff',
                            fontWeight: 'bold'
                          }}>Today's Schedule</h3>
                        </div>
                        {lastUpdated && (
                          <div style={{
                            fontSize: '0.85rem',
                            color: '#999999',
                            fontStyle: 'italic'
                          }}>
                            Updated: {lastUpdated.toLocaleTimeString()}
                          </div>
                        )}
                      </div>

                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                        gap: '15px'
                      }}>
                        {[...onNowLeft, ...onNowRight].map((item, index) => (
                          <div key={index} style={{
                            background: 'linear-gradient(135deg, #12202e 0%, #0d1520 100%)',
                            borderRadius: '8px',
                            padding: '15px',
                            borderLeft: '4px solid #4a9eff',
                            border: '1px solid #2a4a6b'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              marginBottom: '12px'
                            }}>
                              <AccountCircleIcon style={{
                                fontSize: '40px',
                                color: '#4a9eff'
                              }} />
                              <div style={{ flex: 1 }}>
                                <div style={{
                                  fontSize: '1.1rem',
                                  fontWeight: '600',
                                  color: 'white'
                                }}>{item.FIRST_NAME} {item.LAST_NAME}</div>
                                <div style={{
                                  fontSize: '0.9rem',
                                  color: '#cccccc',
                                  fontWeight: '500'
                                }}>{item.POSITION_NAME} {item.CATEGORY_NAME}</div>
                              </div>
                            </div>
                            <div style={{
                              fontSize: '0.85rem',
                              color: '#999999',
                              paddingTop: '10px',
                              borderTop: '1px solid #2a4a6b'
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span><strong>Start:</strong> {item.START_DATE} {item.START_TIME}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px' }}>
                                <span><strong>End:</strong> {item.END_DATE} {item.END_TIME}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Tomorrow's Schedule */}
                  {(onLaterLeft.length > 0 || onLaterRight.length > 0) && (
                    <div className="duty-section" style={{
                      marginBottom: '30px',
                      background: 'linear-gradient(135deg, #1f3652 0%, #12202e 100%)',
                      borderRadius: '12px',
                      padding: '20px',
                      border: '1px solid #2a4a6b',
                      boxShadow: '0 3px 10px rgba(0, 0, 0, 0.3)'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '20px',
                        paddingBottom: '15px',
                        borderBottom: `2px solid #4a9eff`
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <h3 style={{
                            margin: 0,
                            fontSize: '1.6rem',
                            color: '#4a9eff',
                            fontWeight: 'bold'
                          }}>Tomorrow's Schedule</h3>
                        </div>
                        {lastUpdated && (
                          <div style={{
                            fontSize: '0.85rem',
                            color: '#999999',
                            fontStyle: 'italic'
                          }}>
                            Updated: {lastUpdated.toLocaleTimeString()}
                          </div>
                        )}
                      </div>

                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                        gap: '15px'
                      }}>
                        {[...onLaterLeft, ...onLaterRight].map((item, index) => (
                          <div key={index} style={{
                            background: 'linear-gradient(135deg, #12202e 0%, #0d1520 100%)',
                            borderRadius: '8px',
                            padding: '15px',
                            borderLeft: '4px solid #4a9eff',
                            border: '1px solid #2a4a6b'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              marginBottom: '12px'
                            }}>
                              <AccountCircleIcon style={{
                                fontSize: '40px',
                                color: '#4a9eff'
                              }} />
                              <div style={{ flex: 1 }}>
                                <div style={{
                                  fontSize: '1.1rem',
                                  fontWeight: '600',
                                  color: 'white'
                                }}>{item.FIRST_NAME} {item.LAST_NAME}</div>
                                <div style={{
                                  fontSize: '0.9rem',
                                  color: '#cccccc',
                                  fontWeight: '500'
                                }}>{item.POSITION_NAME} {item.CATEGORY_NAME}</div>
                              </div>
                            </div>
                            <div style={{
                              fontSize: '0.85rem',
                              color: '#999999',
                              paddingTop: '10px',
                              borderTop: '1px solid #2a4a6b'
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span><strong>Start:</strong> {item.START_DATE} {item.START_TIME}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px' }}>
                                <span><strong>End:</strong> {item.END_DATE} {item.END_TIME}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Empty State */}
              {column1Data.length === 0 && !showW2W && (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  background: 'linear-gradient(135deg, #1f3652 0%, #12202e 100%)',
                  borderRadius: '12px',
                  border: '1px solid #2a4a6b',
                  boxShadow: '0 3px 10px rgba(0, 0, 0, 0.3)'
                }}>
                  <h3 style={{ color: '#4a9eff', fontSize: '1.5rem', margin: 0 }}>
                    No Crew Members On Duty
                  </h3>
                  <p style={{ color: '#cccccc', fontSize: '1.1rem', marginTop: '10px' }}>
                    Duty crew information will appear here when available
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        // Regular full-width layout for memos and unit status
        <div className="dashboardColumn full-width-column" ref={column2Ref}>
            {currentView === "memos" ? (
              <>
                <h2>Memos</h2>
                <div className="cardList memoCardList">
                  {column2Data.map((item, index) => (
                    <div className="card" key={index}>
                      <div className="cardName">
                        {item.userImg ? (
                          <img
                            className="profilePhoto"
                            src={item.userImg}
                            alt="Profile"
                          />
                        ) : (
                          <img
                            className="profilePhoto"
                            src="https://firebasestorage.googleapis.com/v0/b/ladderemsrn.appspot.com/o/photos%2Favatar.png?alt=media&token=8e349a8b-01d2-4e6b-bc9c-fc23482d2230"
                            alt="Default Profile"
                          />
                        )}
                        <span className="NameTextmemo">{item.userName}</span>
                        {item.postTime && (
                          <span className="postTimestamp">
                            {new Date(item.postTime.seconds * 1000).toLocaleString()}
                          </span>
                        )}
                      </div>
                      <div className="memoContent">
                        {item.post}
                      </div>
                      {item.postImg && (
                        <div className="memoImage">
                          <img
                            src={item.postImg}
                            alt="Memo attachment"
                            className="memoImageContent"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              (() => {
                const filteredUnitsList = units.filter(unit => {
                  if (unit.dataSource === 'rigcheck') {
                    return /\d/.test(unit.name) && !unit.disabled;
                  }
                  return true;
                });
                const totalSubPages = Math.max(1, Math.ceil(filteredUnitsList.length / 15));
                const pageUnits = filteredUnitsList.slice(unitSubPage * 15, (unitSubPage + 1) * 15);

                return (
                  <>
                    <h2>Unit Status{totalSubPages > 1 ? ` (${unitSubPage + 1}/${totalSubPages})` : ''}</h2>
                    <div className="unitSubPageWrapper">
                      <div className="unitSubPage" key={unitSubPage}>
                        <div className="cardList">
                          {pageUnits.map((unit, index) => {
                            let statusClass = 'inService';
                            let statusText = 'In Service';

                            if (unit.dataSource === 'fleet') {
                              if (unit.status === 'Out of Service') {
                                statusClass = 'outOfService';
                                statusText = 'Out of Service';
                              } else if (unit.status === 'Under Maintenance') {
                                statusClass = 'underMaintenance';
                                statusText = 'Under Maintenance';
                              } else if (unit.status === 'In Service') {
                                statusClass = 'inService';
                                statusText = 'In Service';
                              } else {
                                statusClass = 'unknownStatus';
                                statusText = unit.status || 'Unknown';
                              }
                            } else {
                              if (unit.disabledService) {
                                statusClass = 'outOfService';
                                statusText = 'Out of Service';
                              } else {
                                statusClass = 'inService';
                                statusText = 'In Service';
                              }
                            }

                            return (
                              <div className="unitCard" key={unit.id || index}>
                                <div className="unitInfo">
                                  <div className="unitName">{unit.name}</div>
                                  {unit.type && (
                                    <div className="unitType">{unit.type}</div>
                                  )}
                                </div>
                                <div className={`unitStatus ${statusClass}`}>
                                  {statusText}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()
            )}
          </div>
      )}

        {selectedTab === "dashboard" && (
            <div className="countdown-timer">
                <div className="countdown-text">
                    <span className="countdown-icon">⏱️</span>
                    <span>Next: </span>
                </div>
                <div className="countdown-progress">
                    <svg width="30" height="30" viewBox="0 0 30 30">
                        <circle
                            r="12"
                            cx="15"
                            cy="15"
                            fill="transparent"
                            stroke="#444444"
                            strokeWidth="3"
                        />
                        <circle
                            r="12"
                            cx="15"
                            cy="15"
                            fill="transparent"
                            stroke="#4CAF50"
                            strokeWidth="3"
                            strokeDasharray="75.4"
                            strokeDashoffset={totalDuration > 0
                                ? 75.4 * (1 - countdownSeconds / totalDuration)
                                : 0}
                        />
                    </svg>
                    <div className="countdown-number">{countdownSeconds}</div>
                </div>
            </div>
        )}
    </div>
  );
};

export default Dashboard;
